import React from 'react'
import { useAxios } from '../hooks/useAxios'
import { useSearchParams } from 'react-router-dom'
import { restoreValidation } from '../api/restoreValidation'
import Spinner from '../components/Spinner'
import Card from '../components/Card'
import { useForm } from 'react-hook-form'
import TextField from '../components/TextField'
import Btn from '../components/Btn'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import { restorePassword } from '../api/restorePassword'

function RestoreFormPage(): React.ReactElement {
  const { loading, error, fire } = useAxios()
  const { loading: formLoading, error: formError, fire: formFire } = useAxios()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const [done, setDone] = React.useState(false)

  React.useEffect(() => {
    void fire(restoreValidation(String(token)))
  }, [])

  const onSubmit = async (data: any): Promise<void> => {
    const { error } = await formFire(
      restorePassword(data.newPassword, token ?? undefined)
    )

    if (!error) {
      setDone(true)
    }
  }

  if (loading) {
    return <Spinner></Spinner>
  } else if (error) {
    return (
      <div className="auth-layout-view" style={{ maxWidth: '44rem' }}>
        <Card className="auth-layout-view__card auth-card">
          <div className="auth-card__head">
            <h1>Восстановление пароля</h1>
          </div>
          <div className="auth-card__content">
            <p>{error.message}</p>
          </div>
        </Card>
      </div>
    )
  } else {
    return (
      <div className="auth-layout-view" style={{ maxWidth: '44rem' }}>
        <Card className="auth-layout-view__card auth-card">
          <div className="auth-card__head">
            <h1>Восстановление пароля</h1>
          </div>
          {!done ? (
            <div className="auth-card__content">
              <p>Введите новый пароль</p>

              <form
                onSubmit={handleSubmit(onSubmit)}
                className="auth-card-form mt-md-5 mt-sm-4"
              >
                <div className="auth-card-form__fields">
                  <TextField
                    autocomplete={'on'}
                    name="newPassword"
                    control={control}
                    rules={{ required: true }}
                    hasError={!!errors.newPassword || !!formError}
                    errorText={
                      errorDict(errors.newPassword) || formError?.message
                    }
                    type={'password'}
                    label={'Новый пароль'}
                    required
                  ></TextField>
                  <TextField
                    autocomplete={'on'}
                    name="newPasswordRepeat"
                    control={control}
                    rules={{
                      required: true,
                      validate: (value, formValues) => {
                        const { newPassword } = formValues

                        return value === newPassword
                      }
                    }}
                    hasError={!!errors.newPasswordRepeat}
                    errorText={
                      errors.newPasswordRepeat?.type === 'validate'
                        ? ERROR_DICT.passwordsMatches
                        : errorDict(errors.newPasswordRepeat)
                    }
                    type={'password'}
                    label={'Повторите новый пароль'}
                    required
                  ></TextField>
                </div>

                <footer className="auth-card-form__foot">
                  <Btn
                    loading={formLoading}
                    disabled={formLoading}
                    type="submit"
                  >
                    Отправить
                  </Btn>
                </footer>
              </form>
            </div>
          ) : (
            <div className="auth-card__content">
              <p>Пароль успешно изменен</p>

              <div className="u-flex u-flexJustifyCenter mt-md-8 mt-sm-6">
                <Btn to={'/auth'}>На главную</Btn>
              </div>
            </div>
          )}
        </Card>
      </div>
    )
  }
}

export default RestoreFormPage
